import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 82,
	height: 82,
	viewBox: "0 0 82 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M57.7832 50.394C57.7832 50.3274 58.0865 50.272 58.4657 50.272C58.8448 50.272 59.1482 50.3274 59.1482 50.394C59.1482 50.4606 58.8448 50.516 58.4657 50.516C58.0865 50.516 57.7832 50.4606 57.7832 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0479 50.394C55.0479 50.3274 55.3512 50.272 55.7303 50.272C56.1095 50.272 56.4128 50.3274 56.4128 50.394C56.4128 50.4606 56.1095 50.516 55.7303 50.516C55.3512 50.516 55.0479 50.4606 55.0479 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.3076 50.394C52.3076 50.3274 52.6109 50.272 52.9901 50.272C53.3693 50.272 53.6726 50.3274 53.6726 50.394C53.6726 50.4606 53.3693 50.516 52.9901 50.516C52.6109 50.516 52.3076 50.4606 52.3076 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5986 50.394C49.5986 50.3274 49.902 50.272 50.2811 50.272C50.6603 50.272 50.9636 50.3274 50.9636 50.394C50.9636 50.4606 50.6603 50.516 50.2811 50.516C49.902 50.516 49.5986 50.4606 49.5986 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8359 50.394C46.8359 50.3274 47.1447 50.272 47.5238 50.272C47.903 50.272 48.2063 50.3274 48.2063 50.394C48.2063 50.4606 47.8976 50.516 47.5238 50.516C47.1501 50.516 46.8359 50.4606 46.8359 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.1006 50.394C44.1006 50.3274 44.4093 50.272 44.7885 50.272C45.1676 50.272 45.471 50.3274 45.471 50.394C45.471 50.4606 45.1622 50.516 44.7885 50.516C44.4147 50.516 44.1006 50.4606 44.1006 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.3652 50.394C41.3652 50.3274 41.674 50.272 42.0531 50.272C42.4323 50.272 42.7356 50.3274 42.7356 50.394C42.7356 50.4606 42.4269 50.516 42.0531 50.516C41.6794 50.516 41.3652 50.4606 41.3652 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6299 50.394C38.6299 50.3274 38.9386 50.272 39.3178 50.272C39.6969 50.272 40.0003 50.3274 40.0003 50.394C40.0003 50.4606 39.6915 50.516 39.3178 50.516C38.944 50.516 38.6299 50.4606 38.6299 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8945 50.394C35.8945 50.3274 36.2033 50.272 36.577 50.272C36.9508 50.272 37.2649 50.3274 37.2649 50.394C37.2649 50.4606 36.9562 50.516 36.577 50.516C36.1979 50.516 35.8945 50.4606 35.8945 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.1592 50.394C33.1592 50.3274 33.4679 50.272 33.8417 50.272C34.2154 50.272 34.5296 50.3274 34.5296 50.394C34.5296 50.4606 34.2208 50.516 33.8417 50.516C33.4625 50.516 33.1592 50.4606 33.1592 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4238 50.394C30.4238 50.3274 30.7326 50.272 31.1063 50.272C31.48 50.272 31.7942 50.3274 31.7942 50.394C31.7942 50.4606 31.4855 50.516 31.1063 50.516C30.7272 50.516 30.4238 50.4606 30.4238 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6895 50.394C27.6895 50.3274 27.9982 50.272 28.3719 50.272C28.7457 50.272 29.0598 50.3274 29.0598 50.394C29.0598 50.4606 28.7511 50.516 28.3719 50.516C27.9928 50.516 27.6895 50.4606 27.6895 50.394Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7658 49.6167C25.8308 49.6167 25.885 49.9329 25.885 50.3156V50.421L25.7658 50.3045C26.0962 50.3045 26.3454 50.36 26.3454 50.421C26.3454 50.482 26.0962 50.532 25.7658 50.5431H25.6521V50.3156C25.6196 49.9051 25.6737 49.6167 25.7658 49.6167Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 46.7881C25.8306 46.7881 25.8848 47.1043 25.8848 47.487C25.8848 47.8698 25.8306 48.1915 25.7656 48.1915C25.7007 48.1915 25.6465 47.8753 25.6465 47.487C25.6465 47.0987 25.6736 46.7881 25.7656 46.7881Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 43.9878C25.8306 43.9878 25.8848 44.2984 25.8848 44.6867C25.8848 45.075 25.8306 45.3857 25.7656 45.3857C25.7007 45.3857 25.6465 45.075 25.6465 44.6867C25.6465 44.2984 25.6736 43.9878 25.7656 43.9878Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 41.1855C25.8306 41.1855 25.8848 41.4962 25.8848 41.8845C25.8848 42.2728 25.8306 42.5834 25.7656 42.5834C25.7007 42.5834 25.6465 42.2728 25.6465 41.8845C25.6465 41.4962 25.6736 41.1855 25.7656 41.1855Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 38.3848C25.8306 38.3848 25.8848 38.6954 25.8848 39.0837C25.8848 39.472 25.8306 39.7826 25.7656 39.7826C25.7007 39.7826 25.6465 39.472 25.6465 39.0837C25.6465 38.6954 25.6736 38.3848 25.7656 38.3848Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 35.5825C25.8306 35.5825 25.8848 35.8932 25.8848 36.2815C25.8848 36.6698 25.8306 36.9804 25.7656 36.9804C25.7007 36.9804 25.6465 36.6698 25.6465 36.2815C25.6465 35.8932 25.6736 35.5825 25.7656 35.5825Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 32.7822C25.8306 32.7822 25.8848 33.0929 25.8848 33.4812C25.8848 33.8695 25.8306 34.1801 25.7656 34.1801C25.7007 34.1801 25.6465 33.8695 25.6465 33.4812C25.6465 33.0929 25.6736 32.7822 25.7656 32.7822Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 29.981C25.8306 29.981 25.8848 30.2916 25.8848 30.6799C25.8848 31.0682 25.8306 31.3788 25.7656 31.3788C25.7007 31.3788 25.6465 31.0682 25.6465 30.6799C25.6465 30.2916 25.6736 29.981 25.7656 29.981Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 27.1729C25.8306 27.1729 25.8848 27.489 25.8848 27.8773C25.8848 28.2656 25.8306 28.5763 25.7656 28.5763C25.7007 28.5763 25.6465 28.2601 25.6465 27.8773C25.6465 27.4946 25.6736 27.1729 25.7656 27.1729Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 24.3721C25.8306 24.3721 25.8848 24.6883 25.8848 25.0765C25.8848 25.4648 25.8036 25.7644 25.7656 25.7644C25.7277 25.7644 25.6465 25.4482 25.6465 25.0655C25.6465 24.6827 25.6736 24.3721 25.7656 24.3721Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 21.5703C25.8306 21.5703 25.8848 21.8865 25.8848 22.2748C25.8848 22.6631 25.8036 22.9904 25.7656 22.9904C25.7277 22.9904 25.6465 22.6742 25.6465 22.2914C25.6465 21.9087 25.6736 21.5703 25.7656 21.5703Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7656 18.7695C25.8306 18.7695 25.8848 19.0857 25.8848 19.474C25.8848 19.8623 25.8306 20.173 25.7656 20.173C25.7007 20.173 25.6465 19.8568 25.6465 19.474C25.6465 19.0913 25.6736 18.7695 25.7656 18.7695Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.9451 16.1794C25.9451 16.2127 25.8639 16.246 25.7393 16.2682L25.8259 16.1794C25.8497 16.341 25.8605 16.5042 25.8584 16.6676C25.8584 17.0559 25.8043 17.3721 25.7393 17.3721C25.6743 17.3721 25.6201 17.0559 25.6201 16.6676C25.6207 16.5043 25.6316 16.3413 25.6526 16.1794V16.0796H25.7176C25.8639 16.1129 25.9451 16.1462 25.9451 16.1794Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6799 16.1787C28.6799 16.2452 28.3712 16.3007 27.9975 16.3007C27.6237 16.3007 27.3096 16.2452 27.3096 16.1787C27.3096 16.1121 27.6183 16.0566 27.9975 16.0566C28.3766 16.0566 28.6799 16.1121 28.6799 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4157 16.1787C31.4157 16.2452 31.1124 16.3007 30.7333 16.3007C30.3541 16.3007 30.0508 16.2452 30.0508 16.1787C30.0508 16.1121 30.3541 16.0566 30.7333 16.0566C31.1124 16.0566 31.4157 16.1121 31.4157 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.1511 16.1787C34.1511 16.2452 33.8478 16.3007 33.4686 16.3007C33.0895 16.3007 32.7861 16.2452 32.7861 16.1787C32.7861 16.1121 33.0895 16.0566 33.4686 16.0566C33.8478 16.0566 34.1511 16.1121 34.1511 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8864 16.1787C36.8864 16.2452 36.5831 16.3007 36.204 16.3007C35.8248 16.3007 35.5215 16.2452 35.5215 16.1787C35.5215 16.1121 35.8248 16.0566 36.204 16.0566C36.5831 16.0566 36.8864 16.1121 36.8864 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6208 16.1787C39.6208 16.2452 39.3175 16.3007 38.9383 16.3007C38.5592 16.3007 38.2559 16.2452 38.2559 16.1787C38.2559 16.1121 38.5592 16.0566 38.9383 16.0566C39.3175 16.0566 39.6208 16.1121 39.6208 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.3562 16.1787C42.3562 16.2452 42.0528 16.3007 41.6737 16.3007C41.2945 16.3007 40.9912 16.2452 40.9912 16.1787C40.9912 16.1121 41.2945 16.0566 41.6737 16.0566C42.0528 16.0566 42.3562 16.1121 42.3562 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0925 16.1787C45.0925 16.2452 44.7892 16.3007 44.41 16.3007C44.0309 16.3007 43.7275 16.2452 43.7275 16.1787C43.7275 16.1121 44.0309 16.0566 44.41 16.0566C44.7892 16.0566 45.0925 16.1121 45.0925 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8279 16.1787C47.8279 16.2452 47.5245 16.3007 47.1454 16.3007C46.7662 16.3007 46.4629 16.2452 46.4629 16.1787C46.4629 16.1121 46.7662 16.0566 47.1454 16.0566C47.5245 16.0566 47.8279 16.1121 47.8279 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5676 16.1787C50.5676 16.2452 50.2589 16.3007 49.8797 16.3007C49.5006 16.3007 49.1973 16.2452 49.1973 16.1787C49.1973 16.1121 49.506 16.0566 49.8797 16.0566C50.2535 16.0566 50.5676 16.1121 50.5676 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.303 16.1787C53.303 16.2452 52.9943 16.3007 52.6151 16.3007C52.2359 16.3007 51.9326 16.2452 51.9326 16.1787C51.9326 16.1121 52.2414 16.0566 52.6151 16.0566C52.9888 16.0566 53.303 16.1121 53.303 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.0393 16.1787C56.0393 16.2452 55.7306 16.3007 55.3514 16.3007C54.9723 16.3007 54.6689 16.2452 54.6689 16.1787C54.6689 16.1121 54.9777 16.0566 55.3514 16.0566C55.7252 16.0566 56.0393 16.1121 56.0393 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.7747 16.1787C58.7747 16.2452 58.4659 16.3007 58.0868 16.3007C57.7076 16.3007 57.4043 16.2452 57.4043 16.1787C57.4043 16.1121 57.713 16.0566 58.0868 16.0566C58.4605 16.0566 58.7747 16.1121 58.7747 16.1787Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 18.5973C59.0825 18.5973 59.0283 18.2811 59.0283 17.8928C59.0283 17.5045 59.0825 17.1938 59.1475 17.1938C59.2125 17.1938 59.2666 17.51 59.2666 17.8928C59.2666 18.2755 59.2125 18.5973 59.1475 18.5973Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 21.3995C59.0825 21.3995 59.0283 21.0833 59.0283 20.695C59.0283 20.3067 59.0825 19.9961 59.1475 19.9961C59.2125 19.9961 59.2666 20.3123 59.2666 20.695C59.2666 21.0778 59.2125 21.3995 59.1475 21.3995Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 24.2003C59.0825 24.2003 59.0283 23.8841 59.0283 23.4958C59.0283 23.1075 59.0825 22.7969 59.1475 22.7969C59.2125 22.7969 59.2666 23.1131 59.2666 23.4958C59.2666 23.8786 59.2125 24.2003 59.1475 24.2003Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 27.0016C59.0825 27.0016 59.0283 26.6854 59.0283 26.3026C59.0283 25.9199 59.0825 25.5981 59.1475 25.5981C59.2125 25.5981 59.2666 25.9143 59.2666 26.3026C59.2666 26.6909 59.2125 27.0016 59.1475 27.0016Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 29.8028C59.0825 29.8028 59.0283 29.4867 59.0283 29.1039C59.0283 28.7212 59.0825 28.3994 59.1475 28.3994C59.2125 28.3994 59.2666 28.7156 59.2666 29.1039C59.2666 29.4922 59.2125 29.8028 59.1475 29.8028Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 32.6046C59.0825 32.6046 59.0283 32.2884 59.0283 31.9057C59.0283 31.5229 59.0825 31.2012 59.1475 31.2012C59.2125 31.2012 59.2666 31.5174 59.2666 31.9057C59.2666 32.294 59.2125 32.6046 59.1475 32.6046Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 35.4054C59.0825 35.4054 59.0283 35.0892 59.0283 34.7064C59.0283 34.3237 59.0825 34.002 59.1475 34.002C59.2125 34.002 59.2666 34.3181 59.2666 34.7064C59.2666 35.0947 59.2125 35.4054 59.1475 35.4054Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 38.2065C59.0825 38.2065 59.0283 37.8958 59.0283 37.5075C59.0283 37.1192 59.0825 36.8086 59.1475 36.8086C59.2125 36.8086 59.2666 37.1192 59.2666 37.5075C59.2666 37.8958 59.2125 38.2065 59.1475 38.2065Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 41.0077C59.0825 41.0077 59.0283 40.6971 59.0283 40.3088C59.0283 39.9205 59.0825 39.6099 59.1475 39.6099C59.2125 39.6099 59.2666 39.9205 59.2666 40.3088C59.2666 40.6971 59.2125 41.0077 59.1475 41.0077Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 43.8095C59.0825 43.8095 59.0283 43.4989 59.0283 43.1106C59.0283 42.7223 59.0825 42.4116 59.1475 42.4116C59.2125 42.4116 59.2666 42.7223 59.2666 43.1106C59.2666 43.4989 59.2125 43.8095 59.1475 43.8095Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 46.6108C59.0825 46.6108 59.0283 46.3001 59.0283 45.9118C59.0283 45.5235 59.0825 45.2129 59.1475 45.2129C59.2125 45.2129 59.2666 45.5235 59.2666 45.9118C59.2666 46.3001 59.2125 46.6108 59.1475 46.6108Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1475 49.412C59.0825 49.412 59.0283 49.1014 59.0283 48.7131C59.0283 48.3248 59.0825 48.0142 59.1475 48.0142C59.2125 48.0142 59.2666 48.3248 59.2666 48.7131C59.2666 49.1014 59.2125 49.412 59.1475 49.412Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.3884 48.7788H57.9131V51.3138H60.3884V48.7788Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9793 49.1294H24.5039V51.6644H26.9793V49.1294Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.3884 14.6641H57.9131V17.1991H60.3884V14.6641Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9793 14.915H24.5039V17.4501H26.9793V14.915Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M62.8853 70.725C61.9461 70.725 61.1777 69.9609 61.1777 69.0271V61.5305C61.1777 60.5966 61.9461 59.8325 62.8853 59.8325H70.3353C71.2745 59.8325 72.043 60.5966 72.043 61.5305V69.0271C72.043 69.9609 71.2745 70.725 70.3353 70.725H62.8853Z",
			fill: "#F4F8FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.8592 29.3335H14.1931C11.7883 29.3335 9.83887 31.283 9.83887 33.6878V67.46C9.83887 69.8647 11.7883 71.8142 14.1931 71.8142H47.8592C50.2639 71.8142 52.2134 69.8647 52.2134 67.46V33.6878C52.2134 31.283 50.2639 29.3335 47.8592 29.3335Z",
			fill: "#DEDEDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1931 29.3335H47.8592C50.2639 29.3335 52.2134 31.283 52.2134 33.6878V39.3417H9.83887V33.6878C9.83887 31.283 11.7883 29.3335 14.1931 29.3335Z",
			fill: "#E1373B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.2767 55.2196C21.917 55.2196 19.9863 57.1196 19.9863 59.4418C19.9863 61.7641 21.917 63.6641 24.2767 63.6641C26.6363 63.6641 28.567 61.7641 28.567 59.4418C28.567 57.1196 26.6363 55.2196 24.2767 55.2196ZM30.7121 44.6641C28.3525 44.6641 26.4218 46.5641 26.4218 48.8863C26.4218 51.2085 28.3525 53.1085 30.7121 53.1085C33.0718 53.1085 35.0025 51.2085 35.0025 48.8863C35.0025 46.5641 33.0718 44.6641 30.7121 44.6641ZM37.1476 55.2196C34.7879 55.2196 32.8573 57.1196 32.8573 59.4418C32.8573 61.7641 34.7879 63.6641 37.1476 63.6641C39.5073 63.6641 41.4379 61.7641 41.4379 59.4418C41.4379 57.1196 39.5073 55.2196 37.1476 55.2196Z",
			fill: "#707070"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66.8757 24.6367C67.2157 24.1825 67.6144 23.7755 68.0615 23.4263L67.7792 21.8806L70.1697 20.8597L71.0978 22.1401C71.659 22.0586 72.2286 22.0529 72.7912 22.1231L73.6834 20.8313L76.0966 21.7992L75.8333 23.3429C76.2883 23.6819 76.6955 24.0807 77.0437 24.5287L78.5893 24.2465L79.6217 26.6369L78.3488 27.5575C78.43 28.1186 78.4363 28.6881 78.3677 29.2509L79.6577 30.1449L78.6859 32.5581L77.1346 32.31C76.7946 32.7641 76.3959 33.1712 75.9488 33.5204L76.2311 35.0641L73.8406 36.0851L72.92 34.8122C72.3589 34.8934 71.7895 34.8998 71.2266 34.8312L70.3402 36.1211L67.9289 35.1513L68.1789 33.6018C67.7246 33.2614 67.3171 32.8627 66.9666 32.4161L65.4153 32.6983L64.3943 30.3078L65.6672 29.3854C65.586 28.8242 65.5797 28.2548 65.6483 27.692L64.3564 26.7998L65.3263 24.3866L66.8757 24.6367V24.6367ZM69.4632 27.3226C69.2574 27.8343 69.2081 28.3956 69.3214 28.9354C69.4346 29.4751 69.7054 29.9692 70.0995 30.355C70.4936 30.7409 70.9933 31.0012 71.5354 31.103C72.0774 31.2048 72.6375 31.1436 73.1448 30.9271C73.652 30.7106 74.0837 30.3485 74.3851 29.8866C74.6865 29.4247 74.8442 28.8838 74.8382 28.3323C74.8322 27.7808 74.6628 27.2435 74.3513 26.7883C74.0399 26.3331 73.6005 25.9805 73.0886 25.7751C72.4026 25.5003 71.6355 25.5089 70.9558 25.799C70.2761 26.0892 69.7393 26.6371 69.4632 27.3226V27.3226Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M54.7747 30.9781C54.9626 30.7271 55.183 30.5023 55.4301 30.3094L55.2748 29.4552L56.6007 28.8869L57.1103 29.5896C57.4245 29.5471 57.7431 29.5471 58.0574 29.5896L58.5517 28.8755L59.8777 29.4116L59.7394 30.2678C59.991 30.4563 60.2164 30.6773 60.4099 30.925L61.2642 30.7678L61.8325 32.0938L61.1297 32.6033C61.1704 32.9139 61.1704 33.2284 61.1297 33.539L61.8438 34.0334L61.3078 35.3593L60.4497 35.2211C60.2624 35.4724 60.0419 35.6973 59.7943 35.8897L59.9497 36.7459L58.6237 37.3141L58.1142 36.6095C57.8035 36.6553 57.4881 36.6585 57.1766 36.619L56.6841 37.335L55.3487 36.7989L55.487 35.9408C55.2354 35.753 55.01 35.5326 54.8164 35.2855L53.9621 35.4408L53.3939 34.1149L54.0985 33.6053C54.0522 33.2916 54.0484 32.973 54.0872 32.6582L53.373 32.1638L53.9091 30.8379L54.7672 30.9743L54.7747 30.9781ZM56.2049 32.465C56.0909 32.7481 56.0634 33.0587 56.1258 33.3574C56.1882 33.6561 56.3378 33.9297 56.5556 34.1434C56.7735 34.3572 57.0497 34.5016 57.3496 34.5584C57.6495 34.6152 57.9594 34.5818 58.2403 34.4625C58.5212 34.3432 58.7605 34.1433 58.9278 33.8881C59.0952 33.6329 59.1832 33.3338 59.1806 33.0287C59.1781 32.7235 59.0851 32.4259 58.9135 32.1735C58.7419 31.9212 58.4993 31.7253 58.2165 31.6107C58.0283 31.5345 57.827 31.4962 57.624 31.4979C57.421 31.4996 57.2203 31.5413 57.0335 31.6206C56.8466 31.7 56.6773 31.8154 56.5351 31.9603C56.3929 32.1052 56.2807 32.2767 56.2049 32.465V32.465Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M44.2549 13.58C44.5246 12.846 44.8916 12.1516 45.346 11.5153L44.3648 9.58324L47.1227 7.29506L48.8408 8.62099C49.5507 8.29301 50.301 8.06053 51.0721 7.92962L51.7445 5.87253L55.3132 6.20401L55.5935 8.35201C56.328 8.62172 57.0231 8.98867 57.6601 9.44307L59.5921 8.46188L61.8803 11.2217L60.5544 12.9378C60.8834 13.6462 61.1166 14.3954 61.2476 15.1654L63.3066 15.8378L62.9733 19.4065L60.829 19.6773C60.5593 20.4113 60.1924 21.1057 59.738 21.742L60.7173 23.6741L57.9593 25.9622L56.2413 24.6363C55.5313 24.9643 54.781 25.1968 54.01 25.3277L53.3375 27.3848L49.7689 27.0646L49.4886 24.9166C48.7538 24.6479 48.0582 24.2822 47.4201 23.8294L45.4899 24.8106L43.2018 22.0507L44.5277 20.3346C44.198 19.6246 43.9654 18.8735 43.8363 18.1014L41.7773 17.4289L42.1164 13.8603L44.2644 13.58L44.2549 13.58ZM48.729 16.1144C48.6584 16.8716 48.8141 17.6328 49.1761 18.3017C49.5382 18.9705 50.0905 19.5169 50.7632 19.8719C51.4358 20.2268 52.1986 20.3743 52.9551 20.2956C53.7116 20.217 54.4277 19.9158 55.013 19.4302C55.5983 18.9445 56.0265 18.2962 56.2433 17.5672C56.4601 16.8382 56.4558 16.0613 56.231 15.3347C56.0063 14.6081 55.5711 13.9645 54.9805 13.4853C54.39 13.006 53.6705 12.7127 52.9132 12.6423C52.4105 12.5954 51.9034 12.648 51.421 12.7971C50.9386 12.9462 50.4903 13.1889 50.1017 13.5113C49.7131 13.8338 49.3919 14.2296 49.1563 14.6763C48.9208 15.1229 48.7756 15.6116 48.729 16.1144V16.1144Z",
			fill: "#E0E0E0"
		})
	]
});
export default SvgCreateAccount;
